import {defineStore} from 'pinia';
import {ModuleFixedAssetCustom} from '../moduleConst';
import {BaseVoucherStore} from '../baseVoucherStore';
import faVoucherCustomAPI from '@/apis/fa/faVoucherCustomAPI';
import faVoucherListAPI from '@/apis/fa/faVoucherListAPI';
import faVoucherDepreciationAPI from '@/apis/fa/faVoucherDepreciationAPI';
import _ from 'lodash';
// const
import {MSConstant} from '@/commons/wildcards';

const faVoucherCustomStore = new BaseVoucherStore(faVoucherCustomAPI);

export const useFAVoucherCustomStore = defineStore(ModuleFixedAssetCustom, {
  state: () => ({
    ...faVoucherCustomStore.state,
    _config: {
      key: MSConstant.ColumnCommon.refId,
      code: MSConstant.ColumnCommon.refNo,
      table: 'view_fixed_asset_voucher_list',
      posted: MSConstant.ColumnCommon.isPosted,
      //#region Cấu hình mặc định phục vụ lấy data list cho detail (nvthinh 1.4.2024)
      defaultSort: [MSConstant.ColumnCommon.refDate, MSConstant.ColumnCommon.refNo],
      //#endregion
    },
    moduleName: ModuleFixedAssetCustom,
    screenCode: MSConstant.ScreenCode.FAVoucherQLTSList, // Cấu hình này phục vụ lấy lịch sử filter của màn danh sách (nvthinh 29.3.2024)
  }),
  actions: {
    ...faVoucherCustomStore.action,
    /**
     * Thêm
     * @param {*} payload
     * pdtai 25.01.2024: Override
     */
    async insert(payload) {
      const me = this;
      let api = faVoucherListAPI; // Ghi tăng/Ghi giảm/Điều chỉnh TSCĐ
      //Nếu là hao mòn TSCĐ
      if (payload.Model.ref_type == 73) {
        api = faVoucherDepreciationAPI;
      } else {
        api = faVoucherListAPI;
      }

      const res = await api.insert(payload);

      // tvtoan 25.04.2024 nếu res trống thì dùng payload.Model để insert vào list
      if (res == null || res == "") {
        if (Array.isArray(payload.Model)) {
          me.items = [...payload.Model, ...me.items];
        } else {
          me.items = [payload.Model, ...me.items];
        }
      }

      if (res) {
        if (Array.isArray(res)) {
          me.items = [...res, ...me.items];
        } else {
          me.items = [res, ...me.items];
        }
      }
      return res;
    },
    /**
     * Update dữ liệu
     * @param {*} payload
     * pdtai 25.01.2024: Override
     */
    async update(payload) {
      let api = faVoucherListAPI; // Ghi tăng/Ghi giảm/Điều chỉnh TSCĐ
      //Nếu là hao mòn TSCĐ
      if (payload.Model.ref_type == 73) {
        api = faVoucherDepreciationAPI;
      } else {
        api = faVoucherListAPI;
      }
      const res = await api.update(payload);

      // tvtoan 25.04.2024 nếu res trống thì dùng payload.Model để update lại list
      if (res == null || res == "") {
        this.updateItem(payload.Model);
      }

      this.updateItem(res);
      return res;
    },

    /**
     * Lấy chi tiết
     * @param {*} payload
     * pdtai 25.01.2024: Override
     */
    async get(payload) {
      const method = 'get' + payload.action;
      delete payload.action;
      let api = faVoucherListAPI; // Ghi tăng/Ghi giảm/Điều chỉnh TSCĐ
      //Nếu là hao mòn TSCĐ
      if (!_.isEmpty(payload.param) && JSON.parse(payload.param).RefTypeKey == 73) {
        api = faVoucherDepreciationAPI;
      } else {
        api = faVoucherListAPI;
      }
      const res = await api[method](payload);
      return res;
    },
  },
  getters: {
    ...faVoucherCustomStore.getters,
  },
});
